import {GetPrivacyPolicyLink} from 'domain/usecases';

import {makeBFFApiUrl} from 'main/factories/http';
import {RemoteGetPrivacyPolicyLink} from 'data/usecases';
import {ExternalLinkPoint} from 'main/factories/usecases/endpoints';
import {makeAuthorizeHttpClientDecoratorNoToken} from 'main/factories/decorators/authorize-http-client-decorator-factory-no-token';

export const makeGetPrivacyPolicyLink = (): GetPrivacyPolicyLink =>
	new RemoteGetPrivacyPolicyLink(
		makeBFFApiUrl(ExternalLinkPoint.privacyPolicy),
		makeAuthorizeHttpClientDecoratorNoToken(),
	);
